import HtmlSlateWidget from '@plone/volto-slate/widgets/HtmlSlateWidget';
export default HtmlSlateWidget;
